import type { GetInteractor } from '@coris-ts/repository/interactor/get.interactor'
import { GetSectionsSummaryQuery } from '../../data/queries/get-sections-summary.query'
import { type SectionsSummaryEntity } from '../../data/entities/sections.entity'
import { SectionsSummaryEntityToSectionsSummaryMapper } from '../mappers/sections.mappers'
import { type SectionsQueryParams, type SectionsSummary, type UserSegment } from '../models/sections'

export class GetSectionsSummaryInteractor {
  private readonly mapper = new SectionsSummaryEntityToSectionsSummaryMapper()

  constructor(private readonly getSectionsSummary: GetInteractor<SectionsSummaryEntity>) {}

  public async execute(params: SectionsQueryParams & { userSegment: UserSegment }): Promise<SectionsSummary> {
    const entity = await this.getSectionsSummary.execute(
      new GetSectionsSummaryQuery(
        params.fromDate,
        params.toDate,
        params.fromPrevious,
        params.toPrevious,
        params.userSegment,
        params.organization
      )
    )

    return this.mapper.map(entity)
  }
}
